// pages/module-pages/sites/NewSitePage.tsx
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { SiteFormData } from "../../../types/features/Site";
import SiteForm from "../../../components/shared/sites/SiteForm";
import PageLayout from "../../../layouts/PageLayout";
import PageContainer from "../../../components/ui/PageContainer";
import { alertSuccess, alertError } from "../../../helpers/alertError";
import useSites from "../../../hooks/features/sites/useSites";

export default function NewSitePage() {
  const navigate = useNavigate();
  const { createSite } = useSites();
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async (data: SiteFormData) => {
    setIsLoading(true);
    const success = await createSite(data);
    setIsLoading(false);
    if (success) {
      setIsSuccess(true);
      alertSuccess("Site créé avec succès");
      navigate("/admin/sites");
    } else {
      alertError("Erreur lors de la création du site");
    }
  };

  return (
    <PageLayout title="Nouveau site" className="p-6 max-w-4xl mx-auto">
      <PageContainer>
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900">Nouveau site</h1>
          <p className="text-gray-500 mt-1">Créez un nouveau site vitrine pour KAFINTECH Group</p>
        </div>
        <SiteForm isSuccess={isSuccess} onSubmit={handleSubmit} isLoading={isLoading} />
      </PageContainer>
    </PageLayout>
  );
}